export default __webpack_public_path__ + "static/media/verbiage-neutral.a7e5c2a7.png";